var app = angular.module("leonardo");

var UnitStates = function($stateProvider) {

  $stateProvider.state('portfolios.units', {
    url: "/units",
    title: 'Units',
    unit_type: false,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/unit-list.html'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit/list.html',
        controller: 'UnitList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UnitFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Units'
    }
  });

  $stateProvider.state('portfolios.unitsTypes', {
    url: "/units-types",
    title: 'Unit Types',
    only_filter_account: true,
    unit_type: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/unit-type-list.html',
        controller: 'UnitTypeListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit/type-list.html',
        controller: 'UnitTypeList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UnitFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Types'
    }
  });
};

app.config(['$stateProvider', UnitStates]);
